import { render, staticRenderFns } from "./AddExpenseType.vue?vue&type=template&id=004b21a4&"
import script from "./AddExpenseType.vue?vue&type=script&lang=js&"
export * from "./AddExpenseType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports